import React, { useState } from "react";
import "./Login.css";
import logo from "../assets/logo.png";

import { auth, db } from "../firebase";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";

import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

export default function Login({ setUser, lang, setLang }) {
  const [input, setInput] = useState(""); // 🔥 email OR phone
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const text = {
    en: {
      appName: "Connect",
      title: "Mandya Connect",
      email: "Email or Phone",
      password: "Password",
      login: "Login",
      create: "Create Account",
      vendor: "Vendor Register",
      noAccount: "Don't have an account?",
      forgot: "Forgot Password?"
    },
    kn: {
      appName: "ಕನೆಕ್ಟ್",
      title: "ಮಂಡ್ಯ ಕನೆಕ್ಟ್",
      email: "ಇಮೇಲ್ ಅಥವಾ ಫೋನ್",
      password: "ಪಾಸ್‌ವರ್ಡ್",
      login: "ಲಾಗಿನ್",
      create: "ಖಾತೆ ರಚಿಸಿ",
      vendor: "ಮಾರಾಟಗಾರ ನೋಂದಣಿ",
      noAccount: "ಖಾತೆ ಇಲ್ಲವೇ?",
      forgot: "ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?"
    },
  };

  // 🔥 LOGIN WITH EMAIL OR PHONE
  const handleLogin = async (e) => {
    if (e) e.preventDefault();

    if (!input || !password) {
      alert("Enter email/phone & password");
      return;
    }

    try {
      setLoading(true);

      let emailToUse = input;

      // 🔍 CHECK IF INPUT IS PHONE → look up email in BOTH users and vendors
      if (!input.includes("@")) {
        const [userSnap, vendorSnap] = await Promise.all([
          getDocs(query(collection(db, "users"),   where("phone", "==", input))),
          getDocs(query(collection(db, "vendors"), where("phone", "==", input))),
        ]);

        if (!userSnap.empty) {
          emailToUse = userSnap.docs[0].data().email;
        } else if (!vendorSnap.empty) {
          emailToUse = vendorSnap.docs[0].data().email;
        } else {
          alert("Account not found for this phone number");
          setLoading(false);
          return;
        }
      }

      // 🔥 LOGIN USING EMAIL
      const userCredential = await signInWithEmailAndPassword(
        auth,
        emailToUse,
        password
      );

      const user = userCredential.user;

      if (!user.emailVerified) {
        alert("Please verify your email before login");
        setLoading(false);
        return;
      }

      // ✅ CLEAR STALE CACHE before loading fresh data
      localStorage.removeItem("user");
      localStorage.removeItem("vendorData");

      // ✅ FETCH USER OR VENDOR DATA (whichever exists)
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        localStorage.setItem("user", JSON.stringify(userDoc.data()));
      } else {
        const vendorDoc = await getDoc(doc(db, "vendors", user.uid));
        if (vendorDoc.exists()) {
          localStorage.setItem("vendorData", JSON.stringify(vendorDoc.data()));
        }
      }

      setUser(user);

    } catch (error) {
      console.error("LOGIN ERROR:", error);
      alert("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!input.includes("@")) {
      alert("Enter your email to reset password");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, input);
      alert("Password reset email sent ✅");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="login-container">

      <div className="lang-toggle">
        <button onClick={() => setLang("en")}>EN</button>
        <button onClick={() => setLang("kn")}>ಕನ್ನಡ</button>
      </div>

      <div className="login-card">

        <img src={logo} alt="logo" className="logo-img" />

        <h1 className="logo">{text[lang].appName}</h1>
        <h2>{text[lang].title}</h2>

        <input
          type="text"
          placeholder={text[lang].email}
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />

        <input
          type="password"
          placeholder={text[lang].password}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className="login-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Loading..." : text[lang].login}
        </button>

        <p
          style={{
            textAlign: "right",
            marginTop: "8px",
            cursor: "pointer",
            fontSize: "14px"
          }}
          onClick={handleForgotPassword}
        >
          {text[lang].forgot}
        </p>

        <p className="bottom-text">
          {text[lang].noAccount}{" "}
          <span
            className="link"
            onClick={() => navigate("/register")}
          >
            {text[lang].create}
          </span>
        </p>

        <p
          className="vendor"
          onClick={() => navigate("/vendor-register")}
        >
          {text[lang].vendor}
        </p>

      </div>
    </div>
  );
}